import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'customCurrency',
    standalone: false
})
export class CustomCurrencyPipe implements PipeTransform{
    
    transform(text: string) {

        // Regular expression to validate numbers
        const regex = /^(\d{1,3}(,\d{3})*|\d+)([.,]\d+)?$/;

        if(regex.test(text)){

            // Removing commas
            const textWithoutComma = text.replace(',', '');

            // Parsing and formating number
            const n = parseFloat(textWithoutComma);
            const option = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                decimalSeparator: '.',
                groupingSeparator: ','
            }
            const formated = n.toLocaleString('en-US', option);

            return '$' + formated;
        }else{
            return text;
        }
        
    }

}
